import { render } from "./Material-Info.vue?vue&type=template&id=41abf930&scoped=true"
import script from "./Material-Info.vue?vue&type=script&lang=js"
export * from "./Material-Info.vue?vue&type=script&lang=js"

import "./Material-Info.vue?vue&type=style&index=0&id=41abf930&lang=less&scoped=true"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41abf930"]])

export default __exports__